import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { RestaurantDetail } from './pages/RestaurantDetail';
import { Booking } from './pages/Booking';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="w-full min-h-screen bg-gradient-to-br from-slate-50 via-stone-50 to-amber-50" data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/restaurant/:id" element={<RestaurantDetail data-id="element-7" />} data-id="element-6" />
          <Route path="/booking/:id" element={<Booking data-id="element-9" />} data-id="element-8" />
        </Routes>
      </div>
    </BrowserRouter>;
}